const config = {
  switch: {
    knowledgeToManual: {
      enable: true,
      threshhold: 2,
      sopthreshhold: 2,
    },
    hideHistory: false,
    robotToLocal: false,
    manualToRobot: false,
    manualToDefaultServiceGroup: {
      enable: false,
      serviceId: 'd',
    },
    hideCommentManualEntrance: false,
    hideRecommend: false,
  },
  config: {
    greetings: null,
    shortcuts: [{
      bizType: null,
      source: 1,
      isHot: false,
      isNew: false,
      code: 'shortcuts-16',
      name: 'skin',
      means: {
        type: 'text',
        content: 'skin',
      },
      nameEncoded: '5oyR5LiD5aSV56S854mp',
    },
    {
      bizType: null,
      source: 1,
      isHot: false,
      isNew: false,
      code: 'shortcuts-17',
      name: 'login',
      means: {
        type: 'text',
        content: 'login',
      },
      nameEncoded: '5oyR5LiD5aSV56S854mp',
    },
    {
      bizType: null,
      source: 1,
      isHot: false,
      isNew: false,
      code: 'shortcuts-18',
      name: 'liveAgent',
      means: {
        type: 'text',
        content: 'liveAgent',
      },
      nameEncoded: '5oyR5LiD5aSV56S854mp',
    },
    ],
    inputTip: 'Check orders',
    autoWord: 'welcome',
    logo: '',
    welcomeMsg: 'Hi,I`m your shopping assistent!!',
    inputType: 'voice',
    toApassManager: true,
    openbaseType: 'answer.do',
  },
  announcements: [],
  easygoinfo: {
    sessionId: '',
    unfinishedCount: null,
    cancelCount: 0,
    userId: 2295212110,
    canHaveOcsService: false,
    imSid: null,
    ocsGroupId: null,
    lastRequirement: null,
  },
  theme: 'night',
  pluginVersion: {
    weather: '0.1.2',
    flight: '0.0.4',
    voice: '0.0.6',
    coupon: '0.0.3',
    disney: '0.0.01',
    functip: '0.0.2',
    notice: '0.0.1',
    namecard: '0.0.7',
    rate: '0.0.8',
    recharge: '0.0.5',
    orderlist: '0.0.12',
    std: '0.0.6',
    manproduct: '0.0.1',
    weekend: '0.0.04',
    card: '1.1.8',
    confirmorder: '0.0.6',
    sop: '0.2.4',
    addresselector: '0.0.2',
    sendshortcut: '0.1.0',
    classdemo: '0.0.1',
    game: '0.0.6',
    option: '0.0.1',
    commandpic: '0.0.1',
    servicerecord: '0.0.4',
  },
  prime: {
    newFeed: 0,
    count: 0,
  },
  remind: {
    newFeed: 0,
    count: 0,
  },
  botId: '77',
  history: [],
  recommend: {
    operations: [
      {
        id: 102242821687,
        title: 'lazada上线了',
        intro: '',
        link: '//www.lazada.com.my/',
        icon: null,
        image: 'https://gw.alicdn.com/tfs/TB1Q1pLRpXXXXcpXXXXXXXXXXXX-654-243.png',
        time: '2017-05-18T12:57:06.000Z',
      },
    ],
    knowledges: null,
    suggestions: [],
    articles: null,
    briefs: [
      {
        title: 'First level briefing',
        content: null,
        link: null,
        type: null,
        expand: false,
        subContent: [
          {
            title: 'Second level briefing',
            content: 'Second level content',
            link: null,
            type: null,
            expand: false,
            subContent: null,
          },
        ],
      },
    ],
  },
  session: {
    isNeedResume: false,
    continuedResume: false,
  },
  onedata: null,
  user: {
    userId: 2295212110,
    nick: '乐弋',
    phone: ' ',
    gender: 'M',
    memberType: 'normal',
    birth: '19900606',
    todayIsBirthDay: false,
    isFirstVisit: false,
    lastVisitTime: 1495422412461,
    corpId: 0,
  },
  msgbox: null,
  messages: [
  ],
  from: 'unknown',
  imsid: 'd021f9b03e9b11e7a053f363da23eda4',
  connect: false,
  sourceId: '1506162234',
  time: 1495422459083,
  xcode: 'b79de3b1adcadc6824e9a4f3949fb5d2',
  robotCode: 'alicare_intention',
  robotScene: 'alicare_intention_scene',
  skin: 'normal',
  actionTips: {
    managerOnline: {
      type: 'system',
      tip: `[人工小蜜] ${name} 为您提供服务，愉快聊起来~`,
    },
    managerOffline: {
      type: 'system',
      tip: '[人工小蜜] 已退出服务，很高兴遇见您~',
    },
  },
  env: 'pre',
};

export default config;



// WEBPACK FOOTER //
// ./src/app/mockConfig.js